<template>
  <div class="container">
    <el-row :gutter="10" style="height: 90vh; overflow-y: scroll">
      <el-col v-for="(dish, index) in allClassList" :span="3" :key="index">
        <el-card
          class="box-card"
          :body-style="{
            'text-align': 'center',
            height: '110px',
            position: 'relative'
          }"
        >
          <div slot="header" class="clearfix">
            <span style="font-size: 14px">{{
              dish.dish_native_name ? dish.dish_native_name : "暂无"
            }}</span>
          </div>
          <classDishWrapper
            class="class-dish-wrapper"
            :image="dish"
          ></classDishWrapper>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import classDishWrapper from "_c/classDishWrapper";
export default {
  name: "dishDataCheck",
  components: {
    classDishWrapper
  },
  data() {
    return {};
  },
  mounted() {
    this.setSubTitle("数据清洗");
    this.setAllClassList();
  },
  methods: {
    ...mapMutations(["setSubTitle"]),
    ...mapActions(['setAllClassList'])
  },
  computed: {
    ...mapGetters(["allClassList"])
  },
  watch: {}
};
</script>
<style lang="scss" scoped>
.container {
  .class-dish-wrapper {
    display: inline-block;
    width: 100px;
    height: 100px;
  }
}
</style>
